export default __webpack_public_path__ + "static/media/IMG-20210326-WA0036.786f311e.jpg";